// extracted by mini-css-extract-plugin
export default {"root":"DateShareBody-module__[local]___mfycG"};